import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import "../../../../../css/addmember.css";
import Button from "../../../../../components/Buttons/Button";
import { Select } from "antd";
import { getPaymentRecurringOption } from "../../../../../util/Utility";
import { setPlanDetails, addNewPlan, updateAddedNewFlag } from "../../../ownerAction";
import Icon from "../../../../../components/Icon/Icon";
import DefaultModal from "../../../../../components/DefaultModal/DefaultModal";
import { useTranslation } from "react-i18next";

const options = getPaymentRecurringOption();

function AddNewPlan() {
  const dispatch = useDispatch();
  const {t} = useTranslation()
  const [isNext, setIsNext] = useState(false);

  const planDetails = useSelector((state) => state.ownerReducer.plans?.plan_details);

  const isAddedNew = useSelector((state) => state.ownerReducer.isAddedNew);

  const formValidation = () => {
    return !!planDetails?.plan_name &&
      !!planDetails?.amount &&
      !!planDetails?.recurring_type &&
      !!planDetails?.payment_day;
  }

  useEffect(() => {
    if (planDetails) {
      setIsNext(formValidation())
    }
  }, [planDetails])

  const optionPaymentDate = () => {
    let option = [];
    for (let i = 1; i <= 31; i++) {
      const data = {};
      data.label = i;
      data.value = i;
      option.push(data);
    }
    return option;
  }

  const handleChangeUser = (keyName, keyValue) => {
    dispatch(setPlanDetails(keyName, keyValue))
  };

  const handleAddPlan = () => {
    dispatch(addNewPlan());
  }

  const handleAddNew = () => {
    dispatch(updateAddedNewFlag(false));
    window.location.href = "/admin/planModification?new"
  };

  return (
    <div className="add_form">
      <div className="mosque-form">
        <div className="row">
          <div className="col-lg-6">
            <label>
              {t('Plan Name')}<span style={{ color: "#FE1717" }}>*</span>
            </label>
            <input
              value={planDetails?.plan_name}
              onChange={(e) => handleChangeUser("plan_name", e.target.value)}
              type="text"
              placeholder="Plan name"
              className="input-box"
            />
          </div>
          <div className="col-lg-6 ">
            <label>
              {t('Plan Price')}<span style={{ color: "#FE1717" }}>*</span>
            </label>
            <input
              value={planDetails?.amount}
              onChange={(e) => handleChangeUser("amount", e.target.value)}
              type="text"
              placeholder="Plan price"
              className="input-box"
            />
          </div>

          <div className="col-lg-6 pt-5">
            <label>
              {t('Billing Frequency')}<span style={{ color: "#FE1717" }}>*</span>
            </label>
            <Select
              size={"middle"}
              value={planDetails?.recurring_type || "Select type"}
              defaultValue="Select type"
              onChange={(value) => handleChangeUser("recurring_type", value)}
              style={{ width: "100%" }}
              options={options}
            />
          </div>
          <div className="col-lg-6 pt-5">
            <label>
              {t('Payment Date')}<span style={{ color: "#FE1717" }}>*</span>
            </label>
            <Select
              size={"middle"}
              value={planDetails?.payment_day || "Select date"}
              defaultValue="Select date"
              onChange={(value) => handleChangeUser("payment_day", value)}
              style={{ width: "100%" }}
              options={optionPaymentDate()}
            />
          </div>
        </div>
        <Button
          type={!isNext ? "disabled" : "primary"}
          text={t("Save Details")}
          width="15%"
          mt="4"
          mx="auto"
          onClick={() => handleAddPlan()}
        />
        <br />
        <DefaultModal
          show={isAddedNew}
          onHide={() => dispatch(updateAddedNewFlag(false))}
          className="add-mosque-modal"
          centered={true}
          showHeader={false}
          size=""
          showFooter={false}
        >
          <div>
            <Icon
              iconName="modalClose"
              iconSize="xs"
              style={{ marginLeft: "auto" }}
              onClick={() => dispatch(updateAddedNewFlag(false))}
            />
            <div className="text-center add-mosque-modal-content">
              <Icon
                iconName="congratulations"
                style={{ justifyContent: "center" }}
              />
              <div>{t('Congratulations!')}</div>
              <div>
                {t('We have added the new plan. You can make edits to <br/> existing plans anytime.')}
              </div>
              <button onClick={() => handleAddNew()}>{t('Add New plan')} </button>
            </div>
          </div>
        </DefaultModal>
      </div>
    </div>
  );
}

export default AddNewPlan;
